import { render, staticRenderFns } from "./BankEdit.vue?vue&type=template&id=649342c0&scoped=true"
import script from "./BankEdit.vue?vue&type=script&lang=js"
export * from "./BankEdit.vue?vue&type=script&lang=js"
import style0 from "./BankEdit.vue?vue&type=style&index=0&id=649342c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649342c0",
  null
  
)

export default component.exports